import EspecieService from "@/services/EspecieService";

export const especie = {
  namespaced: true,
  state: {
    especie: {},
  },
  actions: {
    getEspecie({ commit }, payload) {
      return EspecieService.GetEspecie(payload).then(
        (especie) => {
          return Promise.resolve(especie);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEspecie({ commit }, payload) {
      return EspecieService.PostEspecie(payload).then(
        (especie) => {
          return Promise.resolve(especie);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEspecie({ commit }, payload) {
      return EspecieService.PutEspecie(payload).then(
        (especie) => {
          return Promise.resolve(especie);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEspecie({ commit }, payload) {
      return EspecieService.DeleteEspecie(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEspecieOData({ commit }, payload) {
      return EspecieService.GetEspecieOData(payload).then(
        (especie) => {
          return Promise.resolve(especie);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default especie;
